import {fetchItems} from '../utils/wishlist';

import ProductCard from './product-card';

export default async function initWishlistItems() {
  const wishlistContainer = document.querySelector('.wishlist-container');
  const itemsWrapper = wishlistContainer?.querySelector('.wishlist__items');
  const recommendationsContainer = document.querySelector('.product-recommendations');
  const rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;

  if (!itemsWrapper) return;

  const wishlistItems = await fetchItems();
  let wishlistItemsCount = wishlistItems.length;

  // Fetch markup for all products saved to wishlist and add to .wishlist__items
  const productPromises = wishlistItems.map(
    (item) =>
      new Promise((resolve, reject) => {
        const handle = item.du.split('products/')[1];
        const url = `${rootUrl}/products/${handle}?view=wishlist&variant=${item.epi}`;

        fetch(url)
          .then((response) => response.text())
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
  );

  Promise.all(productPromises)
    .then((items) => {
      items.forEach((item) => {
        itemsWrapper.insertAdjacentHTML('beforeend', item);
      });

      wishlistContainer.dataset.itemCount = wishlistItemsCount;

      if (wishlistItemsCount > 0) {
        recommendationsContainer.classList.remove('hide');
        dispatchSliderResizeEvent();
      }

      const productCards = itemsWrapper.querySelectorAll('.product-card');
      if (productCards.length > 0) {
        productCards.forEach((product) => {
          ProductCard(product);
        });
      }
    })
    .catch((error) => {
      window.console.log(error);
    });

  // Event listener for addedToWishList; the event is triggered in product-card.js, on wishlist page only
  // When the event is triggered, this will add the new product to .wishlist__items, without refreshing the page
  document.addEventListener('addedToWishList', (event) => {
    const item = event.detail;
    const handle = item.du.split('products/')[1];
    const url = `${rootUrl}/products/${handle}?view=wishlist&variant=${item.epi}`;

    wishlistItemsCount += 1;
    wishlistContainer.dataset.itemCount = wishlistItemsCount;

    fetch(url)
      .then((response) => response.text())
      .then((data) => {
        if (itemsWrapper) {
          itemsWrapper.insertAdjacentHTML('afterbegin', data);
        }

        const productElem = itemsWrapper.querySelector(`[data-product-id="${item.empi}"]`);
        if (productElem) {
          ProductCard(productElem);
        }

        const recommendationsProductElem = recommendationsContainer.querySelector(`[data-product-id="${item.empi}"]`);
        if (recommendationsProductElem) {
          recommendationsProductElem.parentElement.classList.add('hide');
          dispatchSliderResizeEvent();
        }
      })
      .catch((error) => {
        window.console.error(error);
      });
  });

  // Event listener for removedFromWishList; the event is triggered in product-card.js, on wishlist page only
  // When the event is triggered, this will remove the product from .wishlist__items, without refreshing the page
  document.addEventListener('removedFromWishList', (event) => {
    const item = event.detail;

    wishlistItemsCount -= 1;
    wishlistContainer.dataset.itemCount = Number(wishlistItemsCount);

    if (wishlistItemsCount === 0) {
      recommendationsContainer.classList.add('hide');
    }

    const productCard = itemsWrapper.querySelector(`[data-product-id="${item.empi}"]`);
    if (productCard) {
      productCard.parentElement.remove();
    }

    const recommendationsProductElem = recommendationsContainer.querySelector(`[data-product-id="${item.empi}"]`);
    if (recommendationsProductElem) {
      recommendationsProductElem.parentElement.classList.remove('hide');
      dispatchSliderResizeEvent();
    }

    dispatchSliderResizeEvent();
  });
}

function dispatchSliderResizeEvent() {
  document.dispatchEvent(new Event('resizeRecommendationsSlider'));
}
